import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthorizedBaseQuery } from 'store/authorizedBaseQuery';

import { transportOrdersEndpointSchemas } from './transportOrders.schema-map';
import { withOpenApiResponseValidation } from './validatingBaseQuery';

const baseQuery = withOpenApiResponseValidation(
    createAuthorizedBaseQuery(import.meta.env.VITE_MHS_BASE_URL),
    transportOrdersEndpointSchemas
);

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery,
    endpoints: () => ({}),
});
